'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _HorizontalSwitch = require('./HorizontalSwitch');

var _HorizontalSwitch2 = _interopRequireDefault(_HorizontalSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HorizontalSwitch2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/HorizontalSwitch/index.js
// module id = 591
// module chunks = 11